module.exports = __webpack_public_path__ + "static/media/appleColoredIcon.ae32b34a.svg";